<div class="with-floating-button">
    <div class="content">
        <page-header
                [title]="titrePage"
                [listeItems]="listeTabItems"
                (onGoBack)="cancel()">
        </page-header>
        <please-wait *ngIf="isLoading"></please-wait>
        <form *ngIf="!isLoading" #formRelance="ngForm">
            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.bibliotheque.notifications.relances.generalites'"></span>
                </mat-card-title>

                <mat-card-content>
                    <fieldset>
                        <div class="row">
                            <custom-input
                                    ngDefaultControl
                                    name="portee"
                                    customType="select"
                                    libelle="admin.bibliotheque.notifications.relances.portee"
                                    [(ngModel)]="relance.idPortee"
                                    [selectOptions]="listePortee"
                                    optionValue="idPortee"
                                    optionDisplay="libelle"
                                    [required]="true">
                            </custom-input>

                            <label class="col-md-2">
                                <span [translate]="'admin.bibliotheque.notifications.relances.filtreStatut'"></span>
                            </label>

                            <div class="col-md-2">
                                <button mat-button color="primary" class="mt-2" (click)="onClickStatut()">
                                    <span *ngIf="!statutsSelectionnes?.length" [translate]="'admin.bibliotheque.notifications.relances.tousStatuts'"></span>
                                    <span *ngIf="statutsSelectionnes?.length"
                                          [translate]="'admin.bibliotheque.notifications.relances.nbStatuts'"
                                          [translateParams]="{ nb: statutsSelectionnes.length }"></span>
                                    <mat-icon color="primary">search</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="row">
                            <custom-input
                                    ngDefaultControl
                                    name="messageNotif"
                                    customType="select"
                                    libelle="admin.bibliotheque.notifications.relances.message"
                                    [(ngModel)]="relance.idMessage"
                                    [selectOptions]="listeMessage"
                                    optionValue="idMessage"
                                    optionDisplay="titre"
                                    [required]="true">
                            </custom-input>

                            <label class="col-md-2">
                                <span [translate]="'admin.bibliotheque.notifications.relances.filtreRole'"></span>
                            </label>

                            <div class="col-md-2">
                                <button mat-button color="primary" class="mt-2" (click)="onClickRole()">
                                    <span *ngIf="!rolesSelectionnes?.length" [translate]="'admin.bibliotheque.notifications.relances.tousRoles'"></span>
                                    <span *ngIf="rolesSelectionnes?.length"
                                          [translate]="'admin.bibliotheque.notifications.relances.nbRoles'"
                                          [translateParams]="{ nb: rolesSelectionnes.length }"></span>
                                    <mat-icon color="primary">search</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="row">
                            <custom-input
                                    ngDefaultControl
                                    name="param1"
                                    customType="input"
                                    libelle="admin.bibliotheque.notifications.relances.param1"
                                    [(ngModel)]="relance.param1">
                            </custom-input>

                            <custom-input
                                    ngDefaultControl
                                    name="param2"
                                    customType="input"
                                    libelle="admin.bibliotheque.notifications.relances.param2"
                                    [(ngModel)]="relance.param2">
                            </custom-input>
                        </div>

                        <div class="row">
                            <custom-input
                                    ngDefaultControl
                                    name="actif"
                                    customType="checkbox"
                                    libelle="admin.bibliotheque.notifications.relances.actif"
                                    [ngModel]="relance.actif"
                                    [(customModel)]="relance.actif">
                            </custom-input>
                        </div>

                        <div class="row" [class.has-error]="isSqlInvalid">
                            <label
                                    class="col-md-2 align-items-start p-t-15"
                                    [class.required]="true">
                                <span [translate]="'admin.bibliotheque.notifications.relances.conditionSql'"></span>
                            </label>
                            <div class="col-md-9">
                                <ngx-codemirror
                                    #codeMirror
                                    id="sql"
                                    name="sql"
                                    [(ngModel)]="relance.sql"
                                    [options]="codeMirrorOptions"
                                    [class.cursor-default]="isConditionSqlReadonly">
                                </ngx-codemirror>
                            </div>
                        </div>

                        <div class="row">
                            <custom-input
                                    ngDefaultControl
                                    name="commentaire"
                                    customType="textarea"
                                    libelle="admin.bibliotheque.notifications.relances.commentaire"
                                    [(ngModel)]="relance.description"
                                    [areaRows]="4"
                                    [rCol]="10">
                            </custom-input>
                        </div>
                    </fieldset>
                </mat-card-content>
            </mat-card>
        </form>
    </div>

    <floating-button *ngIf="!isLoading" [listeActions]="listeActions" [isPending]="isSaving"></floating-button>
</div>